import { IConfig } from '@cian/config/shared';

import { BOOKING_ENTRY_POINT_SOURCES, CIAN_SOURCE_PARAM } from '../../../../constants/params';
import {
  INewbuildingBrokerSchema,
  TSource,
} from '../../../../repositories/newbuilding-flat-view-order/entities/consulting_request/NewbuildingBrokerSchema';
import { toCamelCase } from '../../../../utils/formatters';

export const prepareNewbuildingBroker = (config: IConfig): INewbuildingBrokerSchema | undefined => {
  const url = new URL(window.location.href);
  const cianSource = url.searchParams.get(CIAN_SOURCE_PARAM);

  if (cianSource) {
    const newbuildingBrokerSources =
      config.get<string[]>('newbuilding-consultants-frontend.brokerSources') ?? BOOKING_ENTRY_POINT_SOURCES;

    if (newbuildingBrokerSources.includes(cianSource)) {
      return {
        source: toCamelCase(cianSource) as TSource,
      };
    }
  }

  return undefined;
};
